import { motion } from "framer-motion";
import { Sparkles, ArrowDown, Star } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_wendy-coloring/artifacts/0o08yzaw_gemini_generated_video_e7e3f5f7.mp4";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 pb-20 sm:pt-40 sm:pb-28 dotted-bg overflow-hidden"
    >
      {/* colorful blobs */}
      <div className="absolute -top-10 -left-16 w-72 h-72 bg-[#FFD166]/40 blob blur-2xl" />
      <div className="absolute top-40 -right-20 w-80 h-80 bg-[#EF476F]/25 blob blur-3xl" />
      <div className="absolute bottom-0 left-1/3 w-64 h-64 bg-[#06D6A0]/25 blob blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center lg:text-left"
        >
          <span className="inline-flex items-center gap-2 font-heading font-semibold text-sm bg-white border-2 border-[#073B4C] rounded-full px-4 py-1.5 shadow-pop">
            <Sparkles size={16} className="text-[#EF476F]" strokeWidth={2.5} />
            Hand Made With AI
          </span>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight mt-6 text-[#073B4C]">
            Magic in every{" "}
            <span className="text-[#EF476F]">stroke</span>
          </h1>

          <p className="font-body text-lg sm:text-xl text-[#073B4C]/70 mt-6 max-w-xl mx-auto lg:mx-0">
            Beautifully detailed coloring books for grown-ups and teens,
            hand made with AI by Wendy. Pick up your pencils and lose yourself
            in the art.
          </p>

          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-9">
            <a
              href="#books"
              data-testid="hero-shop-btn"
              className="inline-flex items-center gap-2 font-heading font-semibold text-lg bg-[#EF476F] text-white border-2 border-[#073B4C] rounded-full px-7 py-3.5 shadow-pop hover:-translate-y-1 hover:rotate-2 transition-transform"
            >
              Shop the Books
            </a>
            <a
              href="#about"
              data-testid="hero-about-btn"
              className="inline-flex items-center gap-2 font-heading font-semibold text-lg bg-white text-[#073B4C] border-2 border-[#073B4C] rounded-full px-7 py-3.5 shadow-pop hover:-translate-y-1 transition-transform"
            >
              Meet Wendy
            </a>
          </div>

          <div className="flex items-center justify-center lg:justify-start gap-2 mt-7">
            <div className="flex text-[#FFD166]">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} fill="#FFD166" strokeWidth={0} />
              ))}
            </div>
            <span className="font-body font-bold text-sm text-[#073B4C]/70">
              Loved by 2,000+ happy colorists
            </span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.94, rotate: -2 }}
          animate={{ opacity: 1, scale: 1, rotate: -2 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="relative"
        >
          <div className="relative border-2 border-[#073B4C] rounded-3xl bg-white shadow-pop-lg overflow-hidden">
            <video
              data-testid="hero-video"
              className="w-full aspect-video object-cover"
              src={VIDEO_URL}
              autoPlay
              muted
              loop
              playsInline
              controls
            />
          </div>
          <span className="absolute -top-4 -right-3 font-heading font-bold text-sm bg-[#06D6A0] text-[#073B4C] border-2 border-[#073B4C] rounded-full px-4 py-1.5 shadow-pop rotate-6">
            Watch the story!
          </span>
        </motion.div>
      </div>

      <div className="flex justify-center mt-16">
        <ArrowDown className="text-[#073B4C]/40 animate-bounce" size={28} />
      </div>
    </section>
  );
}
